var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSandwich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0271 8.04075C15.2641 1.31375 0.757094 1.32575 1.00309 8.04075H15.0271ZM2.11409 7.04075C3.09709 3.00375 12.9741 3.01475 13.9211 7.04075H2.11409ZM1.01509 10.0408C0.956094 11.5268 1.38609 12.9548 4.01509 13.0408H12.0151C14.6471 12.9538 15.0701 11.5288 15.0151 10.0408H1.01509ZM13.9711 11.0408C13.8581 11.7718 13.4531 12.0408 12.0151 12.0408H4.01509C2.58609 12.0408 2.17809 11.7718 2.06209 11.0408H13.9711Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01367 8.53906H15.0137V9.53906H1.01367V8.53906Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSandwich);
export default __webpack_public_path__ + "static/media/ico_sandwich.940cb16d3e5fe872b6f045bd48895df3.svg";
export { ForwardRef as ReactComponent };